import { useEffect, useRef, useState } from "react";
import { postValidityOoptions } from "../utils/request";
export const useValidityOptions = () => {
  const [options, setOptions] = useState([])
  const defaultOption = useRef()
  // const devOptions = [
  //   {
  //     days: 7,
  //     display_name: '7天',
  //     is_default: false
  //   },
  //   {
  //     days: 30,
  //     display_name: '1个月',
  //     is_default: false
  //   },
  //   {
  //     days: 90,
  //     display_name: '3个月',
  //     is_default: false
  //   },
  //   {
  //     days: 180,
  //     display_name: '6个月',
  //     is_default: true
  //   },
  //   {
  //     days: 365,
  //     display_name: '365天',
  //     is_default: false
  //   }
  // ]
  useEffect(() => {
    postValidityOoptions().then(res => {
      if (res && res.status === 200) {
        const options = res.data?.options.map(item => {
          return {
            label: item.display_name,
            value: item.days
          }
        })
        defaultOption.current = res.data?.default_days
        setOptions(options);
      }
      // else if (process.env.NODE_ENV === 'development') {
      //   const options = devOptions?.map(item => {
      //     return {
      //       label: item.display_name,
      //       value: item.days
      //     }
      //   })
      //   defaultOption.current = 180
      //   setOptions(options)
      // }
    })
  }, [])
  return {validityOptions: options, defaultOption}
}